global.sendGetInTouchMail = global.API_ADMIN_URL+'sendGetInTouchMail/';
global.sendContactUsMail = global.API_ADMIN_URL+'sendContactUsMail/';
global.sendRequestADemoMail = global.API_ADMIN_URL+'sendRequestADemoMail/';
global.sendAppDownloadMail = global.API_ADMIN_URL+'sendAppDownloadMail/';
global.sendPartnerUSMail = global.API_ADMIN_URL+'sendPartnerUSMail/';
